import { Component, Input } from '@angular/core';

import { TranslationKeyMap } from './vimeo.i18n';
import { PlaylistItem } from './vimeo.model';

@Component({
    selector: 'cmps-vimeo-now-playing',
    templateUrl: './now-playing.vimeo.component.html',
})
export class NowPlayingVimeoComponent {
    @Input() now: PlaylistItem;
    @Input() next: PlaylistItem;
    i18n = TranslationKeyMap;
}
